// MissionCarousel.jsx
"use client";
import React, { useMemo, useState } from "react";
import { useTranslation } from "../i18n";

export default function MissionCarousel({ headingCentered }) {
  const { t, language } = useTranslation();
  const slides = useMemo(
    () => [
      {
        heading: t("hero.missionCarousel.crisis.heading"),
        content: t("hero.missionCarousel.crisis.content"),
      },
      {
        heading: t("hero.missionCarousel.hope.heading"),
        content: t("hero.missionCarousel.hope.content"),
      },
      {
        heading: t("hero.missionCarousel.mission.heading"),
        content: t("hero.missionCarousel.mission.content"),
      },
      {
        heading: t("hero.missionCarousel.colony.heading"),
        content: t("hero.missionCarousel.colony.content"),
      },
      {
        heading: t("hero.missionCarousel.agile.heading"),
        content: t("hero.missionCarousel.agile.content"),
      },
      {
        heading: t("hero.missionCarousel.marketplace.heading"),
        content: t("hero.missionCarousel.marketplace.content"),
      },
      {
        heading: t("hero.missionCarousel.transparency.heading"),
        content: t("hero.missionCarousel.transparency.content"),
      },
      {
        heading: t("hero.missionCarousel.alignment.heading"),
        content: t("hero.missionCarousel.alignment.content"),
      },
      {
        heading: t("hero.missionCarousel.goal.heading"),
        content: t("hero.missionCarousel.goal.content"),
      },
    ],
    [language, t]
  );
  const [index, setIndex] = useState(0);

  const handleSlide = (step) => {
    setIndex((prev) => (prev + step + slides.length) % slides.length);
  };

  return (
    <div className="bg-background/90 rounded-2xl shadow-lg text-white relative overflow-hidden px-4 sm:px-6 py-5 sm:py-6 min-h-[240px] sm:min-h-[280px]">
      <button
        onClick={() => handleSlide(-1)}
        className="hidden sm:flex items-center justify-center absolute left-2 sm:left-3 top-1/2 -translate-y-1/2 text-2xl sm:text-3xl px-2 text-yellow-400 hover:text-white"
        aria-label="Previous mission"
      >
        &#10094;
      </button>
      <div className={`text-center sm:px-6 ${headingCentered ? "sm:text-center" : "sm:text-left"}`}>
        <h2 className={`text-xl sm:text-2xl font-bold mb-3 sm:mb-4 ${headingCentered ? "text-yellow-400 text-center" : "text-left"}`}>
          {slides[index].heading}
        </h2>
        <p className="text-base sm:text-lg leading-relaxed text-white/90 max-w-full">
          {slides[index].content}
        </p>
      </div>
      <button
        onClick={() => handleSlide(1)}
        className="hidden sm:flex items-center justify-center absolute right-2 sm:right-3 top-1/2 -translate-y-1/2 text-2xl sm:text-3xl px-2 text-yellow-400 hover:text-white"
        aria-label="Next mission"
      >
        &#10095;
      </button>
      <div className="mt-5 flex sm:hidden justify-center gap-3">
        <button
          onClick={() => handleSlide(-1)}
          className="px-3 py-2 rounded-lg bg-white/10 text-sm font-medium"
        >
          {t("common.previous", "Previous")}
        </button>
        <button
          onClick={() => handleSlide(1)}
          className="px-3 py-2 rounded-lg bg-yellow-500 text-olive text-sm font-semibold"
        >
          {t("common.next", "Next")}
        </button>
      </div>
    </div>
  );
}
